import React, { Component } from 'react'
import { SingleWrapper, RowWrapper, LeftLabel, RightInput } from './styles'

class CoordinateField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      coord: this.props.pos
    };
  }

  componentDidUpdate(prevProps) {
    const { pos } = this.props
    if (pos && prevProps.pos !== pos) {
      this.setState({ coord: pos })
    }
  }

  handleInput = (val, key) => {
    let data = { ...this.state.coord }
    data[key] = val
    this.setState({ coord: data }, () => {
      this.props.fn(this.state.coord, this.props.field)
    })
  }

  render() {
    const { pos, disabled, ml = '0' } = this.props

    return (
      <RowWrapper ml={ml}>
        {pos && Object.keys(pos).map((key, i) =>
          <SingleWrapper key={i}>
            <LeftLabel>
              {key.toUpperCase()}
            </LeftLabel>
            <RightInput
              value={this.state.coord[key]}
              onChangeVal={e => this.handleInput(e.target.value, key)}
              disabled={disabled}
            />
          </SingleWrapper>
        )}
      </RowWrapper>
    )
  }
}

export default CoordinateField
